import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerFooterVariants = cva('mt-auto flex gap-2', {
    variants: {
        variant: {
            default: 'flex-col p-4',
            glassy: 'flex-col-reverse border-t border-gray-900/30 px-6 py-5.5 sm:flex-row sm:justify-end md:pb-5 md:pt-4',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export function DrawerFooter({
    className,
    variant,
    ...props
}: React.ComponentProps<'div'> & VariantProps<typeof drawerFooterVariants>) {
    return (
        <div
            data-slot="drawer-footer"
            className={cn(drawerFooterVariants({ variant, className }))}
            {...props}
        />
    );
}
